// extracted by mini-css-extract-plugin
module.exports = {"editor-wrap":"editor_editor-wrap__2aqaF","jump-arrow":"editor_jump-arrow__3OgmB"};